import { createContext, useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PreviousRouteContext = createContext();

export const usePreviousRoute = () => {
  return useContext(PreviousRouteContext);
};

export const PreviousRouteProvider = ({ children }) => {
  const [previousPath, setPreviousPath] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setPreviousPath(location.pathname); // Guarda la ruta actual como la anterior
  }, [location]);

  return (
    <PreviousRouteContext.Provider value={previousPath}>
      {children}
    </PreviousRouteContext.Provider>
  );
};